const money = (n) => (n || n === 0) && !isNaN(n) ? `$${Number(n).toLocaleString()}` : "—";
const Row = ({ label, value, testId }) => (
  <div className="flex justify-between gap-3 py-1"><span className="text-slate-500">{label}</span><span className="text-right font-medium text-slate-800" data-testid={testId}>{value || "—"}</span></div>
);

export const AstoriaDetails = ({ p }) => {
  if (p?.source !== "astoria") return null;
  const consent = Object.entries(p.astoria_consent || {});
  return (
    <div className="mt-4 rounded-lg border border-indigo-200 bg-indigo-50/50 p-4 text-sm" data-testid="astoria-details">
      <div className="mb-2 font-semibold text-indigo-900">Astoria / MortgageLeads.com purchase</div>
      <Row label="Astoria lead ID" value={p.astoria_lead_id} testId="astoria-lead-id" />
      <Row label="Purchasing account" value={p.astoria_account_id} />
      <Row label="Purchase date" value={p.astoria_purchase_date} />
      <Row label="Lead source" value={p.astoria_lead_source} />
      <Row label="Requested loan amount" value={p.requested_loan_amount != null ? money(p.requested_loan_amount) : ""} />
      <Row label="Requested loan type" value={p.requested_loan_type} />
      <Row label="Loan purpose" value={p.loan_purpose} />
      <Row label="Permitted contact methods" value={(p.permitted_contact_methods || []).join(", ")} testId="astoria-contact-methods" />
      <Row label="AI calls allowed by consent" value={p.astoria_ai_call_ok ? "Yes" : "No"} testId="astoria-ai-ok" />
      {p.astoria_initial_call && <Row label="Instant Ava call" value={`${p.astoria_initial_call.status} - ${p.astoria_initial_call.detail}`} testId="astoria-initial-call" />}
      {consent.length > 0 && (
        <div className="mt-2 border-t border-indigo-100 pt-2">
          <div className="mb-1 text-xs font-semibold uppercase tracking-wider text-indigo-700">Consent record</div>
          {consent.map(([k, v]) => <div key={k} className="break-all text-xs text-slate-600"><b>{k.replace(/_/g, " ")}:</b> {String(v)}</div>)}
        </div>
      )}
    </div>
  );
};
